import 'css-chunksrc/client/scenes/moveElement/projectsSelection/zones/zone/projects/project/styles.scss';export default {
  "project": "_project_m21po_1",
  "icon": "_icon_m21po_11",
  "name": "_name_m21po_19"
};